module.exports = __webpack_public_path__ + "static/media/Compassion.0c27eb71.webp";